<template>
  <div class="table-detail">
    <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
    <div class="row">
      <div class="col-xs-12 col-sm-2">
        <div class="text-center">
          <button class="btn btn-info edit-bottom" type="button" @click="handleEdit(item.groupId)">編集</button>
        </div>
      </div>
      <div class="col-xs-12 col-sm-10">
        <div class="col-sm-12 col-xs-12">
          <div id="accordion" class="accordion-style1 panel-group">
            <div class="panel panel-default">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a class="accordion-toggle" data-toggle="collapse" v-bind:href="randomAcountHref(item.groupId)">
                    <i class="ace-icon fa fa-angle-right bigger-110" data-icon-hide="ace-icon fa fa-angle-down" data-icon-show="ace-icon fa fa-angle-right"></i>
                    &nbsp;ゲートグループ詳細
                  </a>
                </h4>
              </div>
              <div class="panel-collapse collapse" :id="randomAcountClass(item.groupId)">
                <div class="panel-body">
                  <div class="profile-user-info profile-user-info-striped">
                    <div class="profile-info-row">
                      <div class="profile-info-name">グループID</div>
                      <div class="profile-info-value">
                        <span class="editable">{{item.groupId}}</span>
                      </div>
                    </div>
                    <div class="profile-info-row">
                      <div class="profile-info-name">グループ名</div>
                      <div class="profile-info-value">
                        <span class="editable">{{item.name}}</span>
                      </div>
                    </div>
                    <div class="profile-info-row">
                      <div class="profile-info-name">ステータス</div>
                      <div class="profile-info-value">
                        <span v-if="item.isValid">有効</span>
                        <span v-else >無効</span>
                      </div>
                    </div>
                    <div class="profile-info-row">
                      <div class="profile-info-name">登録日</div>
                      <div class="profile-info-value">
                        {{ converDate(item.registered) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a class="accordion-toggle" data-toggle="collapse" v-bind:href="randomDeviceHref(item.groupId)" aria-expanded="false" @click="getData" >
                    <i class="ace-icon fa fa-angle-right bigger-110" data-icon-hide="ace-icon fa fa-angle-down" data-icon-show="ace-icon fa fa-angle-right"></i>
                    &nbsp;ユーザー
                  </a>
                </h4>
              </div>
              <div class="panel-collapse collapse" :id="randomDeviceClass(item.groupId)">
                <div class="panel-body">
                  <table style="min-width:100%" class="table table-striped table-bordered table-hover">
                    <thead>
                      <tr>
                        <th>ユーザーID</th>
                        <th>ユーザー名/ふりがな</th>
                        <th>備考.1</th>
                        <th>備考.2</th>
                        <th class="center">ステータス</th>
                      </tr>
                    </thead>
                    <tbody v-if="listUserGroup!==null">
                      <template v-for="(item, index) in listUserGroup">
                        <tr :key="index">
                          <td><a class="link" @click="viewUser(item.user.userId)">{{item.user.userId}}</a></td>
                          <td>{{item.user.name}}/{{item.user.furigana}}</td>
                          <td>{{item.user.option1}}</td>
                          <td>{{item.user.option2}}</td>
                          <td class="center">
                            <span v-if="item.user.isValid">有効</span>
                            <span v-else >無効</span>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="5">{{ message }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="row pd-t-10">
                    <div class="col-xs-12">
                      <div class="dataTables_paginate paging_simple_numbers" v-if="pagesGroupUser>0 && listUserGroup!==null">
                        <paginate
                          :page-count="pagesGroupUser"
                          :page-range="3"
                          :margin-pages="2"
                          :click-handler="handleCurrentChangeGroupUser"
                          :prev-text="'<<'"
                          :next-text="'>>'"
                          :container-class="'pagination'"
                          :page-class="'page-item'">
                        </paginate>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a class="accordion-toggle" data-toggle="collapse" v-bind:href="randomGateHref(item.groupId)" @click="getDataGroupGate">
                    <i class="bigger-110 ace-icon fa fa-angle-right" data-icon-hide="ace-icon fa fa-angle-down" data-icon-show="ace-icon fa fa-angle-right"></i>
                    &nbsp;ゲート
                  </a>
                </h4>
              </div>
              <div class="panel-collapse collapse" :id="randomGateClass(item.groupId)" aria-expanded="true">
                <div class="panel-body">
                  <table style="min-width:100%" class="table table-striped table-bordered table-hover">
                    <thead>
                      <tr>
                        <th>ゲートID</th>
                        <th>ゲート名</th>
                        <th>製品名</th>
                        <th>備考.1</th>
                        <th>備考.2</th>
                        <th class="center">ステータス</th>
                      </tr>
                    </thead>
                    <tbody v-if="listGateGroup!=null">
                      <template v-for="(item, index) in listGateGroup">
                        <tr :key="index" v-if="item.gate.isValid">
                          <td><a class="link" @click="viewGate(item.gate.gateId)">{{item.gate.gateId}}</a></td>
                          <td>{{item.gate.name}}</td>
                          <td>{{item.gate.gateModelName}}</td>
                          <td>{{item.gate.option1}}</td>
                          <td>{{item.gate.option2}}</td>
                          <td class="center">{{item.gate.status}}</td>
                        </tr>
                      </template>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="6">{{ message }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="row pd-t-10">
                    <div class="col-xs-12">
                      <div class="dataTables_paginate paging_simple_numbers" v-if="pagesGroupGate>0 && listGateGroup!==null">
                        <paginate
                          :page-count="pagesGroupGate"
                          :page-range="3"
                          :margin-pages="2"
                          :click-handler="handleCurrentChangeGroupGate"
                          :prev-text="'<<'"
                          :next-text="'>>'"
                          :container-class="'pagination'"
                          :page-class="'page-item'">
                        </paginate>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Config from '../../config'
import moment from 'moment'

export default {
  props: ['item', 'groupId'],
  data () {
    return {
      pagesGroupUser: 0,
      pagesGroupGate: 0,
      exeCount: 0,
      exeCountGroupGate: 0,
      listGateGroup: null,
      listGateGroupTempData: null,
      listUserGroup: null,
      listUserGroupTempData: null,
      listQuery: {
        currPage: 1,
        currPageGroupGate: 1,
        pageSize: 100
      },
      loading: false,
      totalDataRow: 0,
      totalDataRowGroupGate: 0,
      message: 'データー取得中'
    }
  },
  watch: {
    exeCount: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.totalDataRow) {
        vm.getUserInfo(vm.listUserGroupTempData[newVal].userId, newVal)
      } else if (newVal === vm.totalDataRow) {
        vm.listUserGroup = vm.listUserGroupTempData
        vm.loading = false
      }
    },
    exeCountGroupGate: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.totalDataRowGroupGate) {
        vm.getGateInfo(vm.listGateGroupTempData[newVal].gateId, newVal)
      } else if (newVal === vm.totalDataRowGroupGate) {
        vm.listGateGroup = vm.listGateGroupTempData
        vm.loading = false
      }
    }
  },
  methods: {
    sortGroupUser (sortkey, elementname) {
      if ($('#' + elementname).hasClass('sorting_asc')) {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_asc')
        $('#' + elementname).addClass('sorting_desc')
        localStorage.setItem('listGroupUserSortName', 'desc')
      } else {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_desc')
        $('#' + elementname).addClass('sorting_asc')
        localStorage.setItem('listGroupUserSortName', 'asc')
      }
      this.getInforUserGroup(this.groupId)
    },
    sortGroupGate (sortkey, elementname) {
      if ($('#' + elementname).hasClass('sorting_asc')) {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_asc')
        $('#' + elementname).addClass('sorting_desc')
        localStorage.setItem('listGroupGateSortName', 'desc')
      } else {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_desc')
        $('#' + elementname).addClass('sorting_asc')
        localStorage.setItem('listGroupGateSortName', 'asc')
      }
      this.getInforGateGroup(this.groupId)
    },
    getData () {
      this.listUserGroup = null
      this.getInforUserGroup(this.groupId)
    },
    getDataGroupGate () {
      this.listGateGroup = null
      this.getInforGateGroup(this.groupId)
    },
    handleEdit (id) {
      this.$router.push({name: 'groupedit', query: { id: id }})
    },
    viewUser (id) {
      let routeData = this.$router.resolve({name: 'useredit', query: {id: id}})
      window.open(routeData.href, '_blank')
    },
    viewGate (id) {
      let routeData = this.$router.resolve({name: 'gateedit', query: {id: id}})
      window.open(routeData.href, '_blank')
    },
    handleCurrentChangeGroupUser (val) {
      var vm = this
      this.listQuery.currPage = val
      this.exeCount = 0
      this.getInforUserGroup(vm.groupId)
    },
    handleCurrentChangeGroupGate (val) {
      var vm = this
      this.listQuery.currPageGroupGate = val
      this.exeCountGroupGate = 0
      this.getInforGateGroup(vm.groupId)
    },
    getGateInfo (gateId, i) {
      var vm = this
      this.$http.get(Config.GATES_LIST_API + '?gateId=' + encodeURIComponent(gateId) + '&isValid=true')
        .then(response => {
          vm.listGateGroupTempData[i].gateId = response.body.gates[0]
          vm.exeCountGroupGate++
        })
        .catch(error => {
          vm.exeCountGroupGate++
          console.log(error)
        })
    },
    getInforGateGroup (groupId) {
      var vm = this
      vm.loading = true
      vm.exeCountGroupGate = 0
      this.$http.get(Config.RELATION_GATE_GROUP_API + '?groupId=' + encodeURIComponent(groupId) + '&limit=25&page=' + this.listQuery.currPageGroupGate + '&sortKey=desc:gateId&embed=gate&isExceptOptionalGate=true')
        .then(response => {
          console.log(response)
          this.pagesGroupGate = Math.ceil((response.body.maxRecords) / 25)
          // vm.listGateGroupTempData = response.body.relationsGateGroup
          vm.totalDataRowGroupGate = response.body.relationsGateGroup.length
          // vm.getGateInfo(vm.listGateGroupTempData[0].gateId, 0)
          vm.listGateGroup = response.body.relationsGateGroup
          vm.loading = false
        })
        .catch((error) => {
          vm.loading = false
          vm.message = 'データーはありません'
          console.log(error)
        })
    },
    getUserInfo (userId, i) {
      var vm = this
      this.$http.get(Config.USERS_LIST_API + '?userId=' + encodeURIComponent(userId))
        .then(response => {
          vm.listUserGroupTempData[i].userId = response.body.users[0]
          vm.exeCount++
        })
        .catch(error => {
          vm.exeCount++
          console.log(error)
        })
    },
    getInforUserGroup (groupId) {
      var vm = this
      vm.loading = true
      vm.exeCount = 0
      this.$http.get(Config.GROUPS_PASSAGE_API + '?groupId=' + encodeURIComponent(groupId) + '&limit=25&page=' + this.listQuery.currPage + '&sortKey=desc:userId&embed=user')
        .then(response => {
          console.log(response)
          this.pagesGroupUser = Math.ceil((response.body.maxRecords) / 25)
          // vm.listUserGroupTempData = response.body.groupPassages
          vm.totalDataRow = response.body.groupPassages.length
          // vm.getUserInfo(vm.listUserGroupTempData[0].userId, 0)
          vm.listUserGroup = response.body.groupPassages
          vm.loading = false
        })
        .catch((error) => {
          vm.loading = false
          vm.message = 'データーはありません'
          console.log(error)
        })
    },
    removeSpecialSymboy (text) {
      return text.replace(/[^a-z0-9\s]/gi, '-').replace(/[_\s]/g, '-')
    },
    randomAcountClass (classname) {
      return 'acount' + this.removeSpecialSymboy(classname)
    },
    randomAcountHref (classname) {
      return '#acount' + this.removeSpecialSymboy(classname)
    },
    randomDeviceClass (classname) {
      return 'device' + this.removeSpecialSymboy(classname)
    },
    randomDeviceHref (classname) {
      return '#device' + this.removeSpecialSymboy(classname)
    },
    randomGateClass (classname) {
      return 'gate' + this.removeSpecialSymboy(classname)
    },
    randomGateHref (classname) {
      return '#gate' + this.removeSpecialSymboy(classname)
    },
    converDate (t) {
      return moment(new Date(t * 1000)).format('YYYY/MM/DD')
    },
    converTimestamp (t) {
      return parseInt(new Date(t) / 1000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/group/GroupDetail.vue